import { ReactComponent as Icon } from './raw/equipmentbag.svg'
import { SvgIcon, SvgIconProps } from "@mui/material";

const EquipmentBagIcon = (props: SvgIconProps) => {
    return (
      <SvgIcon {...props}>
        <Icon />
      </SvgIcon>
    );
  }

export default EquipmentBagIcon;